<template>
  <section class="section">
    {{ getUserProgress }}
  </section>
</template>

<script>
export default {
  name: 'userProgress',
  computed: {
    getCompletedUserEbooksCount () {
      const userEbooks = this.$store.getters.getUserEbooks
      if (userEbooks && userEbooks.length > 0) {
        return userEbooks.filter(e => e.isCompleted).length
      }
      return 0
    },
    getUserProgress () {
      const completedCount = this.getCompletedUserEbooksCount
      switch (completedCount) {
        case 0:
          return `no ebook completed 😭`
        case 1:
          return `${completedCount} ebook completed 👍`
        case 2:
        case 3:
        case 4:
          return `${completedCount} ebooks completed, you're doing good 🤓`
        default:
          return `${completedCount} books completed, you're on 🔥!!`
      }
    }
  }
}
</script>

<style>

</style>
